export default {
  'TechCard.TechCard': ({ tech }, outlet) => {
    outlet({ id: tech.id })
  },
  'TechCard.TechCard.TechInfo.TechAchievements': ({ tech }, outlet) => {
    outlet({ id: tech.id })
  },
  'TechCard.TechCard.TechImage.TechAchievements': ({ tech }, outlet) => {
    outlet({ id: tech.id })
  }
}